import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToWaitlistSection, WAITLIST_SECTION_ID } from "./joinWaitlist";

/** Paths that render the marketing Home landing (including X /from/:source CTAs). */
export function isHomeLandingPath(pathname: string): boolean {
  return pathname === "/" || /^\/from\/[^/]+$/.test(pathname);
}

/**
 * When the URL hash is #waitlist, scroll to the form after the route renders.
 */
export function useWaitlistHashScroll() {
  const location = useLocation();

  useEffect(() => {
    if (!isHomeLandingPath(location.pathname)) return;
    const hash = location.hash || window.location.hash;
    if (hash !== `#${WAITLIST_SECTION_ID}`) return;

    const frame = window.requestAnimationFrame(() => {
      scrollToWaitlistSection();
      document.getElementById("waitlist-email")?.focus({ preventScroll: true });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [location.pathname, location.hash]);
}
